<template>
  <div class="c-shared-with-you flex flex-1 flex-col">
    <BittsEmptyState
      v-if="partnerPopulationsWithMetadata.length === 0"
      :title="`You cannot see any populations created by ${partnerOrg?.name}`"
      svg-name="emptyStatePartnerNotSharing"
    />
    <div v-else>
      <PartnerPopulationCard
        v-for="pop in STANDARD_POPULATION_TYPES"
        :key="pop"
        :population="standardPopWithMetadata(pop)"
        :is-standard="true"
        class="shared-with-you__partner-population-card"
        @show-modal="openDataShareModal(standardPopWithMetadata(pop))"
      />
      <PartnerPopulationCard
        v-for="population in nonStandardPopulationsWithMetadata"
        :key="population.id"
        :population="population"
        class="shared-with-you__partner-population-card"
        @show-modal="openDataShareModal(population)"
      />
    </div>
  </div>
</template>

<script>
import { BittsEmptyState } from '@crossbeam/bitts';

import { ref } from 'vue';
import { useRoute } from 'vue-router';

import PartnerPopulationCard from '@/components/populations/PartnerPopulationCard.vue';

import useAuth from '@/composables/useAuth';
import usePartnerSharing from '@/composables/usePartnerSharing';
import {
  STANDARD_POPULATION_TYPES,
  emptyPopulation,
} from '@/constants/standard_populations';
import { useDataRequestsStore, usePopulationsStore } from '@/stores';

export default {
  name: 'SharedWithYou',
  components: {
    BittsEmptyState,
    PartnerPopulationCard,
  },
  emits: ['open-data-share-request-modal'],
  setup() {
    const { hasPermission } = useAuth();
    const route = useRoute();
    const partnerOrgId = ref(parseInt(route.params.partner_org_id));
    const { partnerPopulationsWithMetadata, partnerOrg } = usePartnerSharing(
      partnerOrgId.value,
    );
    const { refreshDataRequestsStore } = useDataRequestsStore();

    return {
      hasPermission,
      partnerPopulationsWithMetadata,
      partnerOrg,
      partnerOrgId,
      refreshDataRequestsStore,
      route,
    };
  },
  data() {
    return {
      STANDARD_POPULATION_TYPES,
      requestingPopulationIds: [],
      requestDataErrors: [],
      partnerSources: [],
    };
  },
  computed: {
    nonStandardPopulationsWithMetadata() {
      return this.partnerPopulationsWithMetadata.filter(
        (pop) => !pop.standard_type,
      );
    },
  },
  async mounted() {
    await this.refreshDataRequestsStore();
    if (this.route.query?.partnerPopId) {
      const populationsStore = usePopulationsStore();
      const population = populationsStore.getPartnerPopulationById(
        Number(this.route.query.partnerPopId),
      );
      if (population) {
        this.openDataShareModal(population);
      }
    }
  },
  methods: {
    standardPopWithMetadata(popType) {
      const population = this.getPartnerPopByStandardType(popType);
      if (!population) return emptyPopulation(popType);
      return population;
    },
    openDataShareModal(population) {
      this.$emit('open-data-share-request-modal', {
        orgId: this.partnerOrgId,
        partnerPop: population,
      });
    },
    getPartnerPopByStandardType(standardType) {
      if (this.partnerPopulationsWithMetadata) {
        return this.partnerPopulationsWithMetadata.find(
          (partnerPop) => partnerPop.standard_type === standardType,
        );
      }
      return null;
    },
  },
};
</script>
<style lang="pcss" scoped>
.shared-with-you__partner-population-card {
  @apply mb-16;
}
</style>
